// src/pages/SiteSettingsAdmin.jsx
import React, { useEffect, useState } from "react";
import api from "../api";
import HeroSectionEdit from "../components/HeroSectionEdit";

const SiteSettingsAdmin = () => {
  const [settings, setSettings] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({});

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await api.get("/site-settings/");
      setSettings(res.data);
    } catch (err) {
      console.error("Помилка отримання SiteSettings:", err);
    }
  };

  const startEdit = (item) => {
    setEditing(item);
    setForm(item.value || {});
  };

  const handleChange = (langOrField, field, value) => {
    setForm((prev) => ({
      ...prev,
      [langOrField]: { ...prev[langOrField], [field]: value },
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) setForm({ ...form, file });
  };

  const saveEdit = async () => {
    try {
      if (editing.key === "logo" && form.file) {
        const formData = new FormData();
        formData.append("file", form.file);
        await api.put(`/site-settings/${editing.id}/upload`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        await api.put(`/site-settings/${editing.id}`, { value: form });
      }
      setEditing(null);
      fetchSettings();
    } catch (err) {
      console.error("Помилка збереження:", err);
      alert("Не вдалося зберегти. Перевірте консоль.");
    }
  };

  const cancelEdit = () => setEditing(null);

  const renderTitle = (key) => {
    switch (key) {
      case "footer":
        return "Контактна інформація";
      case "heroSection":
        return "Банер";
      case "logo":
        return "Логотип";
      default:
        return key;
    }
  };

  return (
    <div className="p-4 sm:p-6 bg-[#F5F0E6] min-h-screen">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-[#4B2E2B]">Налаштування сайту</h2>
      </div>

      {!editing && (
        <div className="bg-white border border-[#D2B48C] rounded-2xl shadow p-4">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-[#E8DCC6] text-[#4B2E2B]">
                <th className="text-left p-3 border-b">Назва</th>
                <th className="text-center p-3 border-b">Дія</th>
              </tr>
            </thead>
            <tbody>
              {settings.map((item) => (
                <tr key={item.id} className="hover:bg-[#F8F3EA] transition">
                  <td className="p-3 border-b">{renderTitle(item.key)}</td>
                  <td className="p-3 border-b text-center">
                    <button
                      className="bg-[#A47551] text-white px-3 py-1 rounded-2xl hover:bg-[#8B5E3C]"
                      onClick={() => startEdit(item)}
                    >
                      Редагувати
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {editing && (
        <div className="bg-white border border-[#D2B48C] rounded-2xl shadow p-6 mt-4">
          <h3 className="text-xl font-semibold mb-4 text-[#4B2E2B]">
            Редагування: {renderTitle(editing.key)}
          </h3>

          {editing.key === "heroSection" && (
            <HeroSectionEdit editing={editing} form={form} setForm={setForm} />
          )}

          {editing.key === "footer" &&
            ["ua", "en"].map((lang) => (
              <div key={lang} className="mb-4 border p-3 rounded-xl">
                <h4 className="font-bold mb-2">{lang.toUpperCase()}</h4>
                {["email", "phone", "instagram", "tiktok", "address"].map((field) => (
                  <div key={field} className="mb-2">
                    <label className="block text-sm mb-1">{field}:</label>
                    <input
                      type="text"
                      className="w-full p-2 border rounded"
                      value={form[lang]?.[field] || ""}
                      onChange={(e) => handleChange(lang, field, e.target.value)}
                    />
                  </div>
                ))}
              </div>
            ))}

          {editing.key === "logo" && (
            <div className="flex flex-col gap-4">
              {form.url && (
                <img
                  src={form.url}
                  alt="Поточне лого"
                  className="w-32 h-32 object-cover rounded-full border"
                />
              )}
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className="border p-2 rounded"
              />
            </div>
          )}

          <div className="flex gap-2 mt-6">
            <button
              className="bg-green-600 text-white px-4 py-2 rounded-2xl hover:bg-green-700"
              onClick={saveEdit}
            >
              Зберегти
            </button>
            <button
              className="bg-gray-400 text-white px-4 py-2 rounded-2xl hover:bg-gray-500"
              onClick={cancelEdit}
            >
              Відмінити
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SiteSettingsAdmin;

// import React, { useEffect, useState } from "react";
// import api from "../api";
// import HeroSectionEdit from "../components/HeroSectionEdit";

// const SiteSettingsAdmin = () => {
//   const [settings, setSettings] = useState([]);
//   const [editing, setEditing] = useState(null);
//   const [form, setForm] = useState({});

//   useEffect(() => {
//     fetchSettings();
//   }, []);

//   const fetchSettings = async () => {
//     try {
//       const res = await api.get("/site-settings/");
//       setSettings(res.data);
//     } catch (err) {
//       console.error("Помилка отримання SiteSettings:", err);
//     }
//   };

//   const startEdit = (item) => {
//     setEditing(item);
//     setForm(item.value);
//   };

//   const handleChange = (langOrField, field, value) => {
//     setForm((prev) => ({
//       ...prev,
//       [langOrField]: { ...prev[langOrField], [field]: value },
//     }));
//   };

//   const saveEdit = async () => {
//     try {
//       await api.put(`/site-settings/${editing.id}`, { value: form });
//       setEditing(null);
//       fetchSettings();
//     } catch (err) {
//       console.error("Помилка збереження:", err);
//       alert("Не вдалося зберегти. Перевірте консоль.");
//     }
//   };

//   const cancelEdit = () => {
//     setEditing(null);
//   };

//   const getDisplayName = (key) => {
//     switch (key) {
//       case "footer":
//         return "Контактна інформація";
//       case "heroSection":
//         return "Банер";
//       default:
//         return key;
//     }
//   };

//   // Модальне вікно (в тому ж стилі, що ProductsPage)
//   const renderModal = (content, title) => (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-6">
//       <div
//         className="absolute inset-0 bg-black/40"
//         onClick={cancelEdit}
//       />
//       <div className="relative w-full max-w-[95vw] sm:max-w-2xl md:max-w-4xl bg-white rounded-2xl shadow-2xl border border-[#D2B48C] max-h-[90vh] overflow-y-auto">
//         <div className="sticky top-0 bg-white/90 backdrop-blur px-5 sm:px-6 py-4 border-b flex items-center justify-between rounded-t-2xl">
//           <h3 className="text-lg font-semibold text-[#4B2E2B]">{title}</h3>
//           <button
//             onClick={cancelEdit}
//             className="rounded-full w-9 h-9 grid place-items-center border hover:bg-gray-50"
//           >
//             ×
//           </button>
//         </div>
//         <div className="px-5 sm:px-6 py-5">{content}</div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="p-4 sm:p-6 bg-[#F5F0E6] min-h-screen">
//       <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
//         <h2 className="text-2xl font-bold text-[#4B2E2B]">Налаштування сайту</h2>
//       </div>

//       {!editing && (
//         <div className="overflow-x-auto bg-white border border-[#D2B48C] rounded-2xl shadow-sm">
//           <table className="w-full">
//             <thead className="bg-[#E9DFC9] text-[#4B2E2B]">
//               <tr>
//                 <th className="text-left p-3 font-semibold">Назва</th>
//                 <th className="text-center p-3 font-semibold">Дія</th>
//               </tr>
//             </thead>
//             <tbody>
//               {settings.map((item) => (
//                 <tr
//                   key={item.id}
//                   className="border-t border-[#D2B48C] hover:bg-[#FAF6EE] transition"
//                 >
//                   <td className="p-3">{getDisplayName(item.key)}</td>
//                   <td className="p-3 text-center">
//                     <button
//                       className="bg-[#A47551] text-white px-4 py-2 rounded-2xl hover:bg-[#8B5E3C]"
//                       onClick={() => startEdit(item)}
//                     >
//                       Редагувати
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {editing &&
//         renderModal(
//           editing.key === "heroSection" ? (
//             <HeroSectionEdit editing={editing} form={form} setForm={setForm} />
//           ) : (
//             ["ua", "en"].map((lang) => (
//               <div key={lang} className="mb-4 border p-4 rounded-lg shadow-sm">
//                 <h3 className="font-bold mb-3 text-lg">{lang.toUpperCase()}</h3>
//                 {["email", "phone", "instagram", "tiktok", "address"].map(
//                   (field) => (
//                     <div key={field} className="mb-2">
//                       <label className="block mb-1 capitalize text-sm text-gray-700">
//                         {field}:
//                       </label>
//                       <input
//                         type="text"
//                         className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-[#A47551]/50"
//                         value={form[lang]?.[field] || ""}
//                         onChange={(e) =>
//                           handleChange(lang, field, e.target.value)
//                         }
//                       />
//                     </div>
//                   )
//                 )}
//               </div>
//             ))
//           ),
//           `Редагування: ${getDisplayName(editing.key)}`
//         )}
      
//       {editing && (
//         <div className="fixed bottom-5 left-1/2 -translate-x-1/2 flex gap-3 z-50">
//           <button
//             className="bg-green-600 text-white px-5 py-2 rounded-2xl hover:bg-green-700 shadow-md"
//             onClick={saveEdit}
//           >
//             Зберегти
//           </button>
//           <button
//             className="bg-gray-400 text-white px-5 py-2 rounded-2xl hover:bg-gray-500 shadow-md"
//             onClick={cancelEdit}
//           >
//             Відмінити
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SiteSettingsAdmin;





// import React, { useEffect, useState } from "react";
// import api from "../api";
// import HeroSectionEdit from "../components/HeroSectionEdit";


// const SiteSettingsAdmin = () => {
//   const [settings, setSettings] = useState([]);
//   const [editing, setEditing] = useState(null);
//   const [form, setForm] = useState({});

//   useEffect(() => {
//     fetchSettings();
//   }, []);

//   const fetchSettings = async () => {
//     try {
//       const res = await api.get("/site-settings/");
//       setSettings(res.data);
//     } catch (err) {
//       console.error("Помилка отримання SiteSettings:", err);
//     }
//   };

//   const startEdit = (item) => {
//     setEditing(item);
//     setForm(item.value); // підтягуємо існуючі дані
//   };

//   const handleChange = (langOrField, field, value) => {
//     setForm((prev) => ({
//       ...prev,
//       [langOrField]: { ...prev[langOrField], [field]: value },
//     }));
//   };

//   const saveEdit = async () => {
//     try {
//       await api.put(`/site-settings/${editing.id}`, { value: form });
//       setEditing(null);
//       fetchSettings();
//     } catch (err) {
//       console.error("Помилка збереження:", err);
//       alert("Не вдалося зберегти. Перевірте консоль.");
//     }
//   };

//   const cancelEdit = () => {
//     setEditing(null);
//   };

//   return (
//     <div className="p-4">
//       <h1 className="text-2xl mb-4">Адмін-панель SiteSettings</h1>

//       {!editing && (
//         <table className="w-full border">
//           <thead>
//             <tr>
//               <th className="border p-2">Key</th>
//               <th className="border p-2">Preview</th>
//               <th className="border p-2">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {settings.map((item) => (
//               <tr key={item.id}>
//                 <td className="border p-2">{item.key}</td>
//                 <td className="border p-2">
//                   <pre className="text-sm">{JSON.stringify(item.value, null, 2)}</pre>
//                 </td>
//                 <td className="border p-2">
//                   <button
//                     className="bg-blue-500 text-white px-2 py-1 rounded"
//                     onClick={() => startEdit(item)}
//                   >
//                     Edit
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}

//       {editing && (
//         <div className="mt-4">
//           <h2 className="text-xl mb-2">Редагування: {editing.key}</h2>

//           {editing.key === "heroSection" ? (
//             <HeroSectionEdit editing={editing} form={form} setForm={setForm} />
//           ) : (
//             ["ua", "en"].map((lang) => (
//               <div key={lang} className="mb-4 border p-2 rounded">
//                 <h3 className="font-bold mb-2">{lang.toUpperCase()}</h3>
//                 {["email", "phone", "instagram", "tiktok", "address"].map((field) => (
//                   <div key={field} className="mb-2">
//                     <label className="block mb-1">{field}:</label>
//                     <input
//                       type="text"
//                       className="w-full p-2 border rounded"
//                       value={form[lang]?.[field] || ""}
//                       onChange={(e) => handleChange(lang, field, e.target.value)}
//                     />
//                   </div>
//                 ))}
//               </div>
//             ))
//           )}

//           <div className="flex gap-2 mt-2">
//             <button
//               className="bg-green-500 text-white px-4 py-2 rounded"
//               onClick={saveEdit}
//             >
//               Зберегти
//             </button>
//             <button
//               className="bg-gray-400 text-white px-4 py-2 rounded"
//               onClick={cancelEdit}
//             >
//               Відмінити
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SiteSettingsAdmin;




